import React from 'react';
import TokenCardItem from './TokenCardItem';

const TokenCardItems = ({ category, items, allowUserLink }) => (
  items.map((item, index) => (
    <TokenCardItem
      key={`tokens_list_item_${item.code}`}
      category={category}
      token={item}
      upward={index > 4}
      allowUserLink={allowUserLink}
    />
  ))
);

export default TokenCardItems;
